import React, { ReactNode } from "react";
import { Container as ThemeContainer, ThemeUIStyleObject } from "theme-ui";

type Props = {
  children?: ReactNode;
  as?: React.ElementType;
  variant?: string;
  sx?: ThemeUIStyleObject | undefined;
  onSubmit?: React.FormEventHandler<HTMLDivElement> | undefined;
};

export const Container: React.FC<Props> = ({
  children,
  as,
  sx,
  variant,
  onSubmit,
}) => {
  return (
    <ThemeContainer
      sx={{ ...sx }}
      as={as}
      variant={variant}
      onSubmit={onSubmit}
    >
      {children}
    </ThemeContainer>
  );
};
